@if ($isMenuAllowed() && !$isHiddenForGuest()) {
    @if ($isMenuExpandable()) {
        <div class="toggle-main-menu">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    }
}
